import React, { useEffect } from "react"
import { useEnvironment } from "../../../core/Global";
import ThemeToggle from "../../base/ThemeToggle";
import "./AuthLayout.css";

function AuthLayout(props: { children: any }) {

    const env = useEnvironment();

    useEffect(() => {

    }, [])

    return (
        <div className="d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed auth-shell"
            style={{ backgroundImage: "url(/assets/media/illustrations/sketchy-1/14.png" }}>

            <ThemeToggle />

            {/* Logo and card together, centred in the window as one block. Measured as one so the
                gap above the logo and the gap below the card are always the same -- stacked from
                the top with fixed margins they were not, and the pair sat high on a tall screen
                and overflowed a short one. */}
            <div className="auth-main">

                <div className="text-center mt-20 mb-5 auth-brand">
                    <a>
                        <img alt={env.siteTitle} src={`/assets/brands/${env.brand}/icon.png`} style={{
                            width: 100,
                            maxWidth: "60%"
                        }} />
                    </a>
                </div>

                <div className="w-100 bg-body rounded shadow-sm p-10 p-lg-15 mx-auto auth-card"
                    style={{
                        maxWidth: 500
                    }}>
                    {props.children}
                </div>

            </div>

        </div>
    );
}

export default AuthLayout;
